import React, { useState, useRef } from 'react';
import { IconButton, Modal, Box, Button } from '@mui/material';
import { Close, ZoomIn, ZoomOut, Download, Print } from '@mui/icons-material';

const PreviewModal = ({ openModal, selectedImage, setOpenModal, setSelectedImage }) => {
	const [scale, setScale] = useState(1);
	const [position, setPosition] = useState({ x: 0, y: 0 });
	const [isDragging, setIsDragging] = useState(false);
	const [startDrag, setStartDrag] = useState({ x: 0, y: 0 });
	const imageRef = useRef(null);

	const handleClose = () => {
		setOpenModal(false);
		setSelectedImage('');
		setScale(1);
		setPosition({ x: 0, y: 0 });
	};

	const handleWheel = (e) => {
		e.preventDefault();
		const delta = e.deltaY > 0 ? 0.9 : 1.1;
		setScale((prev) => Math.max(0.5, Math.min(prev * delta, 3)));
	};

	const handleMouseDown = (e) => {
		if (scale > 1) {
			setIsDragging(true);
			setStartDrag({
				x: e.clientX - position.x,
				y: e.clientY - position.y
			});
		}
	};

	const handleMouseMove = (e) => {
		if (isDragging) {
			setPosition({
				x: e.clientX - startDrag.x,
				y: e.clientY - startDrag.y
			});
		}
	};

	const handleMouseUp = () => {
		setIsDragging(false);
	};

	const resetZoom = () => {
		setScale(1);
		setPosition({ x: 0, y: 0 });
	};

	const handleDownload = () => {
		const link = document.createElement('a');
		link.href = selectedImage;
		link.download = 'imagen_descargada.jpg'; // puedes cambiar la extensión según el formato
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const handlePrint = () => {
		const printWindow = window.open('', '_blank');
		printWindow.document.write(`
			<html>
				<head>
					<title>Imprimir Imagen</title>
					<style>
						body, html {
							margin: 0;
							padding: 0;
							text-align: center;
							background: #fff;
						}
						img {
							max-width: 100%;
							max-height: 100vh;
						}
					</style>
				</head>
				<body>
					<img src="${selectedImage}" alt="Imagen a imprimir" />
					<script>
						window.onload = function() {
							window.print();
							window.onafterprint = function() { window.close(); }
						}
					</script>
				</body>
			</html>
		`);
		printWindow.document.close();
	};

	return (
		<div>
			<Modal
				open={openModal}
				onClose={handleClose}
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					p: 2
				}}
			>
				<Box
					role="dialog"
					aria-modal="true"
					aria-label="Foto en grande"
					sx={{
						position: 'relative',
						maxWidth: '95vw',
						maxHeight: '95vh',
						outline: 'none',
						overflow: 'hidden',
						cursor: scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default'
					}}
					onWheel={handleWheel}
					onMouseDown={handleMouseDown}
					onMouseMove={handleMouseMove}
					onMouseUp={handleMouseUp}
					onMouseLeave={handleMouseUp}
				>
					{/* Botones de control */}
					<Box
						sx={{
							position: 'absolute',
							top: 16,
							right: 16,
							zIndex: 10,
							display: 'flex',
							gap: 1
						}}
					>
						<IconButton
							sx={{
								width: 40,
								height: 40,
								backgroundColor: 'rgba(0, 0, 0, 0.5)',
								color: 'white',
								'&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
							}}
							onClick={() => setScale((prev) => Math.min(prev + 0.2, 3))}
							aria-label="Acercar"
						>
							<ZoomIn />
						</IconButton>

						<IconButton
							sx={{
								width: 40,
								height: 40,
								backgroundColor: 'rgba(0, 0, 0, 0.5)',
								color: 'white',
								'&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
							}}
							onClick={() => setScale((prev) => Math.max(prev - 0.2, 0.5))}
							aria-label="Alejar"
						>
							<ZoomOut />
						</IconButton>

						<Button
							sx={{
								backgroundColor: 'rgba(0, 0, 0, 0.5)',
								color: 'white',
								'&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
							}}
							onClick={resetZoom}
						>
							100%
						</Button>
						<IconButton
							sx={{
								width: 40,
								height: 40,
								backgroundColor: 'rgba(0, 0, 0, 0.5)',
								color: 'white',
								'&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
							}}
							onClick={handleDownload}
							aria-label="Descargar"
						>
							<Download />
						</IconButton>

						<IconButton
							sx={{
								width: 40,
								height: 40,
								backgroundColor: 'rgba(0, 0, 0, 0.5)',
								color: 'white',
								'&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
							}}
							onClick={handlePrint}
							aria-label="Imprimir"
						>
							<Print />
						</IconButton>

						<IconButton
							sx={{
								width: 40,
								height: 40,
								backgroundColor: 'rgba(0, 0, 0, 0.5)',
								color: 'white',
								'&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
							}}
							onClick={handleClose}
							aria-label="Cerrar"
						>
							<Close />
						</IconButton>
					</Box>
					{/* <IconButton
						sx={{
							position: 'absolute',
							top: 8,
							right: 8,
							backgroundColor: 'rgba(0, 0, 0, 0.5)',
							color: 'white',
							'&:hover': {
								backgroundColor: 'rgba(0, 0, 0, 0.7)'
							}
						}}
						onClick={handleClose}
							aria-label="Cerrar"
					>
						<Close />
					</IconButton> */}
					{/* <img
						src={selectedImage}
						alt="Vista ampliada"
						style={{
							maxWidth: '100%',
							maxHeight: '100%',
							objectFit: 'contain'
						}}
					/> */}
					{/* Contenedor de la imagen con transform */}
					<Box
						sx={{
							width: '100%',
							height: '100%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
							transition: isDragging ? 'none' : 'transform 0.1s'
						}}
					>
						<img
							ref={imageRef}
							src={selectedImage}
							alt="Vista ampliada"
							// Al alto y al ancho de la pantalla (menos el margen del Modal): una foto vertical se ve
							// completa, no cortada abajo. El 100 % no limitaba porque el contenedor no tiene alto fijo.
							style={{
								display: 'block',
								maxWidth: 'calc(95vw - 32px)',
								maxHeight: 'calc(95vh - 32px)',
								objectFit: 'contain',
								userSelect: 'none'
							}}
						/>
					</Box>

					{/* Indicador de zoom */}
					<Box sx={{ position: 'absolute', bottom: 16, left: 16, zIndex: 10 }}>
						<Box
							sx={{
								backgroundColor: 'rgba(0, 0, 0, 0.5)',
								color: 'white',
								px: 1,
								py: 0.5,
								borderRadius: 1,
								fontSize: '0.875rem'
							}}
						>
							{Math.round(scale * 100)}%
						</Box>
					</Box>
				</Box>
			</Modal>
		</div>
	);
};

export default PreviewModal;
